export type EventOSTabId = "overview" | "live" | "team";
export type PnLTabId = "overview" | "pnl" | "tickets" | "risk";
export type TabId = EventOSTabId | PnLTabId;
export type WorkspaceArea = "event-os" | "pnl";

export const tabLabels: Record<TabId, string> = {
  overview: "Overview",
  pnl: "Finance",
  tickets: "Tickets",
  team: "Team",
  risk: "Risk",
  live: "Live Ops",
};

// The Command Center "Team" tab is intentionally hidden.
// Gate team is managed from Profile (Team on gate), not from Live Ops.
export const eventOsTabs: EventOSTabId[] = ["overview", "live"];
export const pnlTabs: PnLTabId[] = ["overview", "pnl", "tickets", "risk"];
